import { API_BASE } from './api';

export function wsBase(): string {
    return API_BASE.replace(/^http/, 'ws');
}
